// Tiny translation helper for the paywall + Stripe-checkout mini-localization
// project. Dependency-free — resolves a dot-path key (e.g. "billing.subscribe")
// against the active locale's dictionary, falling back to English, then to the
// key itself if nothing matches. Supports {param} interpolation.
//
// Keys are shaped like i18next namespaces on purpose so a future migration to a
// real i18n library (see LOCALIZATION_SPEC.md) is mechanical rather than a
// rewrite.

import { paywallLocale, type PaywallLocale } from "./locale";
import { strings } from "./strings";

type Params = Record<string, string | number>;

function lookup(locale: PaywallLocale, key: string): string | undefined {
  const dict = strings[locale];
  if (!dict) return undefined;
  let node: unknown = dict;
  for (const segment of key.split(".")) {
    if (typeof node !== "object" || node === null) return undefined;
    node = (node as Record<string, unknown>)[segment];
  }
  return typeof node === "string" ? node : undefined;
}

function interpolate(template: string, params?: Params): string {
  if (!params) return template;
  return template.replace(/\{(\w+)\}/g, (match, name) => {
    const value = params[name];
    return value === undefined ? match : String(value);
  });
}

export function t(key: string, params?: Params): string {
  const resolved =
    lookup(paywallLocale, key) ?? lookup("en", key) ?? key;
  return interpolate(resolved, params);
}
